// src/pages/Blog.jsx
import { blogs } from '../models/portfolioData';

export default function Blog() {
  return (
    <section className="section" id="blog">
      <div className="container text-center">
        <p className="section-subtitle">Recent Posts?</p>
        <h6 className="section-title mb-6">Blog</h6>

        {/* Blog Cards Container */}
        <div className="max-w-4xl mx-auto space-y-8">
          {blogs.map((b) => (
            <div key={b.id} className="blog-card">
              <div className="blog-card-header bg-[#0f0f17]">
                <img
                  src={b.image}
                  alt={b.title}
                  className="blog-card-img"
                />
              </div>

              <div className="blog-card-body">
                <h5 className="blog-card-title">{b.title}</h5>

                <div className="blog-card-caption">
                  <span>By: Ismail Jabiulla</span>
                  <span>
                    <i className="ti-bookmark text-primary mr-1"></i> {b.publication}
                  </span>
                  <span>
                    <i className="ti-calendar text-primary mr-1"></i> {b.date}
                  </span>
                </div>

                <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 leading-relaxed">
                  {b.description}
                </p>

                {/* Tags */}
                <div className="flex flex-wrap gap-1.5 mb-2">
                  {b.tags.map((tag) => (
                    <span
                      key={tag}
                      className="bg-gray-100 dark:bg-[#232334] text-gray-600 dark:text-gray-400 text-xs px-2.5 py-0.5 rounded border border-gray-200 dark:border-[#2b2b3d]"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>

                {b.link && (
                  <a
                    href={b.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="blog-card-link"
                  >
                    Read more <i className="ti-angle-double-right"></i>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
